<div class="overflow-auto">
	<app-teranet-summary-docket></app-teranet-summary-docket>
</div>
